import LanguageDropdown from "components/Language/LanguageDropdown"
import React, {Component} from "react"
import Responsive from "react-responsive"
import {observer} from "mobx-react"
import {Container, Modal, Button, Icon, Menu, Dropdown} from "semantic-ui-react"
import {Link, NavLink} from "react-router-dom"
import CartButton from "components/Cart/CartButton"
import shop from "shop/shop"

import MenuBySlug from "components/Menu/MenuBySlug"

import settingStore from "stores/settingStore"
import languageStore from "stores/languageStore"
import app from "app.controller"
import "style/header.scss"

// import Navigation from "../Navigation/Navigation"
@observer
export default class Header extends Component {

    constructor() {
        super()
        this.state = {
            list: shop.orderlist.default, categoryData: false
        }
    }

    componentDidMount() {
        shop.events.loaded.add(this.handleLoad)
        if (shop.orderlist.default)
            shop.orderlist.default.events.change.add(this.handleOrderlist)
    }

    handleOrderlist = ({list}) => {
        this.setState({
            list
        })
    }

    handleLoad = () => {
        this.setState({
            categoryData: shop.categories
        })
    }

    componentWillUnmount() {
        if (shop.orderlist.default)
            shop.orderlist.default.events.change.remove(this.handleOrderlist)
        shop.events.loaded.remove(this.handleLoad)
    }

    render() {
        const {showMini} = this.state
        return (<header className={`header ${showMini}`}>
            <Responsive maxWidth={790}>
                <div>
                    {showMini && <MiniHeaderMobile/>}
                    <OnOffset
                        offset={95}
                        onPassedReverse={() => {
                            this.setState({showMini: false})
                        }}
                        onPassed={() => {
                            this.setState({showMini: "scrolled"})
                        }}>
                        <MobileHeader/>
                    </OnOffset>
                </div>
            </Responsive>
            <Responsive minWidth={790}>
                <div>
                    {showMini && <MiniHeader/>}
                    <OnOffset
                        offset={95}
                        onPassedReverse={() => {
                            this.setState({showMini: false})
                        }}
                        onPassed={() => {
                            console.log("scrolled")
                            this.setState({showMini: "scrolled"})
                        }}>
                        <DesktopHeader/>
                    </OnOffset>
                </div>
            </Responsive>
        </header>)
    }
}

class MobileHeader extends Component {
    render() {
        const {inverted = false} = this.props
        return (<div className="MobileHeader">
            <div className="pa3 ph4">
                <div className="">
                    <Button basic inverted={inverted} icon="bars" onClick={app.sidebarLeft.toggle.dispatch}/>
                    <SettingsModal inverted={inverted}/>
                    <div className="fr">
                        <Button basic inverted={inverted} icon="search" as={Link} to={"/search/"}/>
                        <CartButton inverted={inverted}/>
                    </div>
                </div>
            </div>
        </div>)
    }
}


const SettingsModal = ({inverted}) => {
    return (<Modal trigger={<Button basic inverted={inverted} icon="settings"/>}>
        <Modal.Content>
            <SettingsMenu vertical/>
        </Modal.Content>
    </Modal>)
}

const SettingsMenu = observer((props) => {
    const currentMode = settingStore.get("orderMode")

    return (<Menu secondary
                  borderless
                  fluid
                  {...props}
                  size="small">

        <Menu.Item
            className={"pre-order-mode-link"}
            active={currentMode === "MODE_AVAILABLE"}
            as={Link}
            to="/home/">{translate("MODE_AVAILABLE")}</Menu.Item>
        <Menu.Item
            className={"pre-order-mode-link"}
            active={currentMode === "MODE_PREORDER"}
            as={Link}
            to="/home/">{translate("MODE_PREORDER")}</Menu.Item>

        {/* RIGHT SIDE MENU*/}
        {(shop.session && shop.session.handId) && <Menu.Item
            as={Link}
            to="/login/accounts/">
            <Icon name="users"/>
            {translate("Kunden")}
        </Menu.Item>}
        {/* RIGHT SIDE MENU*/}


        {/* LEFT SIDE MENU */}
        {shop.session && <Menu.Item
            position="right"
            as={Link}
            to="/orderlist/">{translate("Orderlist")}</Menu.Item>}


        {shop.session && <Menu.Item
            as={Link}
            to="/quickorder/">{translate("Quickorder")}</Menu.Item>}

        {shop.session && <Menu.Item
            as={Link}
            to="/account/">{translate("My Account")}</Menu.Item>}
        {shop.session && <Menu.Item
            as={Link}
            to="/logout/">{translate("Logout")}</Menu.Item>}

        {!shop.session && <Menu.Item
            position="right"
            as={Link}
            to="/login">{translate("Login")}</Menu.Item>}
        <LanguageDropdown/>
    </Menu>)
})

class DesktopHeader extends Component {
    render() {
        return (<div>

            <div className="top-menu-mini absolute top-0 left-0 right-0 z-3">
                <SettingsMenu/>
            </div>

            <OnOffset
                offset={95}
                onPassedReverse={() => {
                    this.setState({showMini: false})
                }}
                onPassed={() => {
                    this.setState({showMini: "scrolled"})
                }}>
                <div className="top-menu bg-primary pa3">
                    <Container className="relative">
                        <div className="absolute left-1 top-0 ">
                            {/*<Responsive maxWidth={1298}><Button icon="bars" onClick={app.sidebarLeft.toggle.dispatch}/></Responsive>*/}
                            <NavLink to="/" className={"Logo"}>
                                <img
                                    src={"/ci/ARNOLDSPORTS-WHITE-CLAIM-RGB@640.png"}
                                    alt="zur Startseite"/>
                            </NavLink>
                            {/*<Button basic> DE <Icon name="caret down"/></Button>*/}
                        </div>

                        <div className="absolute right-0 top-0 mt3 pt2">
                            <MenuBySlug
                                key={"mini-header"}
                                slug={"header"}
                                secondary
                                borderless>
                                <Menu.Item as={Link} to="/search"><Icon inverted name="search"/></Menu.Item>
                                {shop.session && <Menu.Item><CartButton inverted/></Menu.Item>}
                                <Responsive maxWidth={1024}><Menu.Item onClick={app.sidebarLeft.toggle.dispatch}><Icon
                                    name="bars"/></Menu.Item></Responsive>
                            </MenuBySlug>
                            {/*{!shop.session && <div><Link to="/login">Anmelden</Link> oder <Link to="/customer_registration">Registrieren</Link></div>}*/}
                        </div>

                        <div className="tc pb3">
                            <div className="logo--shop block"> </div>
                        </div>
                        {/*<Menu slug="menu-en"/>*/}
                    </Container>
                </div>
            </OnOffset>
            {/*<MenuUtility list={list}/>*/}
            <div className="container-fluid navigation-bar">
                {/*<MenuCustomCategories/>*/}
            </div>
        </div>)
    }
}

const MiniHeaderMobile = () => <div
    className="mini-header z-9 fixed top-0 left-0 right-0   bg-white animate  fadeInDown">
    <div className="ph2">
        <Menu borderless
              secondary>
            <Menu.Item onClick={app.sidebarLeft.toggle.dispatch}><Icon name="bars"/></Menu.Item>
            {/*<Menu.Item><SettingsButton/></Menu.Item>*/}
            <Menu.Item as={Link} to="/orderlist" position="right"><Icon name="like"/></Menu.Item>
            <Menu.Item
                as={Link}
                to="/search"><Icon name="search"/></Menu.Item>
            {shop.session && <Menu.Item><CartButton/></Menu.Item>}
        </Menu>
    </div>
</div>


const MiniHeader = () => <div className="mini-header z-9 fixed top-0 left-0 right-0   bg-white animate  fadeInDown">
    <div className="ph2">
        <MenuBySlug slug={"header"}
                    key={"mini-header-main"}
                    secondary
                    borderless>
            <Menu.Item
                position="right"
                content={translate("Orderlist")}
                as={Link}
                to="/orderlist"/>
            <Menu.Item
                as={Link}
                to="/search"><Icon name="search"/></Menu.Item>
            {shop.session && <Menu.Item><CartButton/></Menu.Item>}
        </MenuBySlug>
    </div>
</div>


class OnOffset extends Component {

    state = {
        passed: false
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll)
        this.handleScroll()
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll)
    }

    handleScroll = () => {
        let {passed} = this.state
        let {pageYOffset} = window
        if (pageYOffset > this.props.offset) {
            if (!passed) {
                this.setState({passed: true})
                this.props.onPassed && this.props.onPassed()
            }
        } else {
            if (passed) {
                this.setState({passed: false})
                this.props.onPassedReverse && this.props.onPassedReverse()
            }
        }
    }

    render() {
        return this.props.children || null
    }
}





// WEBPACK FOOTER //
// ./src/theme/arnoldsports/components/Header/Header.js